import { selectChangeMessageForLinks } from '@UI/aside/asideLinks/asideLinksSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import type { EditAsideLinks, RootEditComponent } from '@nodeTypeConfig/configTypes';
import { menuItemReference } from './menuItemReference';

export const proLinks: EditAsideLinks = {
  component: 'linkGroup',
  reactComponent: 'AsideLinks',
  asideChangeMessageSelector: selectChangeMessageForLinks,
  label: 'Links',
  options: {
    type: 'group',
  },
  hiddenChildren: {
    containerType: ContentType.LINK_GROUP,
    items: [
      {
        type: ContentType.REFERENCE,
        label: 'link',
      },
    ],
  },
};

export const proLinksAndMenuReferences: Array<RootEditComponent> = [menuItemReference, proLinks];
